let controller = new AbortController()

export function catalogHttpSignal (): AbortSignal {
  return controller.signal
}

export function abortCatalogHttp (): void {
  controller.abort()
  controller = new AbortController()
}

export function followCatalogHttpAbort (request: AbortController): () => void {
  const signal = controller.signal
  if (signal.aborted) {
    request.abort()
    return () => {}
  }
  const onAbort = () => {
    request.abort()
  }
  signal.addEventListener('abort', onAbort, { once: true })
  return () => {
    signal.removeEventListener('abort', onAbort)
  }
}

export function bindWretchCatalogAbort (
  chain: { controller: () => [AbortController, ...unknown[]] },
): () => void {
  const [request] = chain.controller()
  return followCatalogHttpAbort(request)
}

export function isAbortError (error: unknown): boolean {
  return error instanceof Error && error.name === 'AbortError'
}
